export const setCredential = () => {
  const { host } = window.location;
  if (host.match(/localhost/g)) {
    return "same-origin";
  }
  return "include";
};

// Для React-Query и axios
export const setCredentials = (): boolean => {
  const { host } = window.location;
  return !host.match(/localhost/g);
};

export const setHeaders = (headers: Headers) => {
  // Добавим кастомный заголовок
  headers.set("f-v", import.meta.env.VITE_APP_VERSION_APP);

  return headers;
};
